import { useEffect, useRef } from "react";
import CloseIcon from "../../assets/images/icons/x-black.svg";
interface IDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  width?: string;
  header?: string;
  customStyle?: string;
  ariaLabel?: string;
  headerCustomStyle?: string;
}

const Drawer: React.FC<IDrawerProps> = ({
  isOpen,
  onClose,
  children,
  header,
  customStyle,
  ariaLabel,
  headerCustomStyle,
}) => {
  const drawerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  const handleBackdropClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const ariaAttributes = ariaLabel
    ? { "aria-label": ariaLabel }
    : header
      ? { "aria-labelledby": "drawer-title" }
      : {};

  return (
    <div
      className={`fixed inset-0 z-40 flex items-center justify-end transition-opacity duration-300 ${
        isOpen
          ? "pointer-events-auto bg-black/40 opacity-100"
          : "pointer-events-none opacity-0"
      }`}
      onClick={handleBackdropClick}
      role="dialog"
      aria-modal="true"
      {...ariaAttributes}
    >
      <div
        className={`relative flex h-full w-40 transform flex-col gap-4 overflow-hidden bg-white px-3 shadow-custom transition-all duration-300 ease-in-out ${
          isOpen
            ? "translate-x-0 opacity-100"
            : "opacity-0 ltr:translate-x-full rtl:-translate-x-full"
        } ${customStyle}`}
        ref={drawerRef}
      >
        <div
          className={
            "mb-4 flex min-h-[68px] items-center justify-between gap-2 border-b"
          }
        >
          {header && (
            <h4
              id="drawer-title"
              className={`px-5 text-lg font-bold ${headerCustomStyle}`}
            >
              {header}
            </h4>
          )}
          <button
            type="button"
            className="rounded text-4xl"
            onClick={onClose}
            aria-label="Close drawer"
          >
            <img src={CloseIcon} alt="CloseIcon" />
          </button>
        </div>
        <div className="flex h-full flex-col gap-4" id="drawer-description">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Drawer;
